import React from 'react';
import { IAirline } from '@move-frontend/dap';
import styled from '@emotion/styled';
import { Grid } from '../../../../../ui';
import {
	AirlineColumn,
	CanceledColumn,
	FlightDetailColumns,
} from './detail-row';
import { isCanceledFlight } from '../../../shared/flight/domain/use-cases/helpers/isCanceledFlight';
import { IFlightPublicStatus } from '../../../shared/status/domain/models/IFlightPublicStatus';
import Responsive from '../../../../../ui/utils/Responsive';

const StyledDetailsRow = styled.div`
	background-color: #f7f7f7;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		background-color: #ffffff;
	}
`;

const StyledGrid = styled(Grid)`
	margin-left: 0px;
	margin-top: 0px;
`;

interface IProps {
	airline?: IAirline;
	icaoOperatingAirline: string;
	codeShareFlightNumber: string;
	bestKnownTimestamp: number;
	scheduledTimestamp: number;
	gate: string;
	arrival: boolean;
	isDelayed: boolean;
	status: IFlightPublicStatus;
	baggageBelt: string[];
}

export const DetailsRow = ({
	bestKnownTimestamp,
	scheduledTimestamp,
	airline,
	icaoOperatingAirline,
	codeShareFlightNumber,
	status,
	gate,
	arrival,
	isDelayed,
	baggageBelt,
}: IProps) => {
	const isCanceled = isCanceledFlight(status);

	return (
		<StyledDetailsRow>
			<StyledGrid>
				<AirlineColumn
					airline={airline}
					icaoOperatingAirline={icaoOperatingAirline}
					codeShareFlightNumber={codeShareFlightNumber}
					columns={[3, { mobileXL: 12 }]}
				/>

				{isCanceled ? (
					<CanceledColumn
						codeShareFlightNumber={codeShareFlightNumber}
						columns={[9, { mobileXL: 12 }]}
					/>
				) : (
					<FlightDetailColumns
						bestKnownTimestamp={bestKnownTimestamp}
						scheduledTimestamp={scheduledTimestamp}
						codeShareFlightNumber={codeShareFlightNumber}
						gate={gate}
						arrival={arrival}
						isDelayed={isDelayed}
						baggageBelt={baggageBelt}
					/>
				)}
			</StyledGrid>
		</StyledDetailsRow>
	);
};
